


























































































































































import { Component, Vue } from "vue-property-decorator";
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import {
  InspectRecommend,
  InspectRecommendCategory,
  InspectRecommendSubItem
} from "@/model/InspectRecommend";
import { inspectService } from "@/service/inspectService";
import requestService from "@/service/requestService";
import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import * as util from "@/service/util";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { INSPECT_TYPE } from "@/model/InspectType";
import { RouteInfo } from "@/model/RouteInfo";
import { SocketControllers } from "@/service/SocketControllers";

const namespaceInspect = "Inspect";
@Component({
  components: {
    ButtonInspect,
    ButtonInspectGroup,
    InputNumber,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin
  }
})
export default class RecommendMaintenance extends Vue {
  data: InspectRecommend = {};
  service: inspectService;
  reqService: requestService;
  sktControll: SocketControllers;
  activeCategory: number = 0;
  currentData: InspectRecommendSubItem[] = [];
  loadData: boolean = false;
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  timerSave: any = null;
  timerClick: any;
  clickCount: number = 0;
  tempInspect: InspectRecommendSubItem;
  tempIndex: number = -1;
  activeInspect: any = {};
  msgAskChangeInspectResult: string = MESSAGE.AskChangeInspectResult;
  tempListSave: InspectRecommendSubItem[] = [];
  arrStatus: number[] = [];
  isSaving: boolean = false;
  tempWaitSave: any = [];
  qmMitsumori: any = {};
  seibiNm: string = "";
  kouchinZn: any = null;
  kouchinZk: any = null;
  kingakuFlg: boolean = false;
  maxRowNum: number = 0;
  isSocket: boolean = false;

  $refs!: {
    buttonGroup: ButtonInspectGroup[];
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    confirmDialog: ConfirmDialog;
    confirmRegisterDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("recommend", { namespace: namespaceInspect })
  recommend: InspectRecommend;
  @Getter("hasRecommendData", { namespace: namespaceInspect })
  hasData: boolean;

  @Action("setInspectRecommend", { namespace: namespaceInspect })
  setInspect: any;
  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  @Getter("currentState", { namespace: "FunctionSetting" })
  functionSettingState: any;
  /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  @Action("setState", { namespace: "QuickMitsumoriQrInfo" })
  setStateQuickMitsumoriQrInfo: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2021-11-24 sh #7530 improve speed.(for back) [START] */
  @Getter("currentState", { namespace: "RouteState" })
  lastSelectedCategoryInfo!: (index: number) => RouteInfo;
  @Getter("hasState", { namespace: "RouteState" })
  hasLastSelectedCategoryInfo!: (index: number) => boolean;

  @Action("setState", { namespace: "RouteState" })
  setRouteInfo: any;
  /** 2021-11-24 sh #7530 improve speed.(for back) [END] */

  created() {
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.service = new inspectService();
    this.$emit("onactivepage", this.$route.name);

    // if (this.hasData) {
    //   this.data = this.recommend;
    //   this.setCurrentData();
    //   this.loadData = true;
    // } else {
    /** [START] for quick mitsumori */
    // this.reqService.getInspectRecommend(this.uketsukeExtendsId).then(
    //  (res: InspectRecommend) => {
    //    if (res) {
    //      this.setProgressState({
    //        stateId: res.sknWorkProgressStateId,
    //        stateNm: res.sknWorkProgressStateNm
    //      });
    //      this.initData(res);
    //    }
    //  },
    //  (err: any) => {
    //    this.loadData = true;
    //    this.onError(err);
    //  }
    //);
    this.getInitData();
    /** [END] for quick mitsumori */
    // }


    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
    this.sktControll.connectSocket(this.onConnect);
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

  }

  getInitData() {
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
    this.loadData = false;
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
    this.reqService.getInspectRecommend(this.uketsukeExtendsId).then(
      (res: any) => {
        if (res) {
          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });
          this.initData(res);
        }
      },
      (err: any) => {
        this.loadData = true;
        this.onError(err);
      }
    );
  }

  initData(res: any) {
    if (res.recommend) {
      const promise = res.recommend.map((cate: InspectRecommendCategory) => {
        let sumStatus = 0;
        cate.subItems = cate.subItems.map((obj: InspectRecommendSubItem) => {
          this.changeStatus(obj, false);
          if (obj.status) {
            sumStatus += obj.status;
          }
          if (obj.rowNum > this.maxRowNum) this.maxRowNum = obj.rowNum;
          return {
            ...obj,
            showWork: false
          };
        });
        this.setCateStatus(sumStatus, cate.subItems.length, cate);
        return cate;
      });
      /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
      // Promise.all(promise).then((val: any) => {
      //   this.data = { recommend : val };
      //   this.setInspect(this.data);
      //   this.setCurrentData();
      // });
      const pmQmMitsumoriPreview = this.getQmMitsumoriPreviewPM();
      Promise.all([promise, pmQmMitsumoriPreview]).then((val: any) => {
        if (val.length > 0) {
          this.data = { recommend : val[0] };
          this.setInspect(this.data);
          this.setCurrentData();

          /** 2021-11-24 sh #7530 improve speed. (for back) [START] */
          this.changeCategoryByLastSelected(val[0].length);
          /** 2021-11-24 sh #7530 improve speed. (for back) [END] */
        }
        if (val.length > 1) {
          this.qmMitsumori = val[1];
          console.log("recMaintenance.initData pmQmMitsumoriPreview => ", this.qmMitsumori);
          /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
          this.setStateQuickMitsumoriQrInfo(val[1]);
          /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */
        }
      });
      /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    }
  }

  setCurrentData() {
    if (this.isSaving) {
      return;
    }
    if (this.data.recommend) {
      let kingakuZn = this.data.recommend[this.activeCategory].kingakuZn ? this.data.recommend[this.activeCategory].kingakuZn: null;
      let kingakuZk = this.data.recommend[this.activeCategory].kingakuZk ? this.data.recommend[this.activeCategory].kingakuZk: null
      if ((kingakuZn && kingakuZn > 0) || (kingakuZk && kingakuZk > 0)) {
        this.kingakuFlg = true;
      }
      this.loadData = true;
      let currentData = this.data.recommend[this.activeCategory].subItems.map(
        (item: InspectRecommendSubItem) => {
          return {
            ...item,
            isSaving: false
          };
        }
      );
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [START] */
      this.currentData = []; // 一旦空にする
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [END] */
      Promise.all(currentData).then(vals => {
        vals.map((val: any, i: number) => {
          this.$set(this.currentData, i, util.deepCopy(val));
        });
      });
    }
  }

  onCheckAll(data: { isActive: boolean; value: number }) {
    const btnIndex = this.service.findIndexOnScreen();
    let nChange = 0;
    for (let i = btnIndex.start; i <= btnIndex.end; i++) {
      let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
      if (!this.isDuplicate(this.currentData[i])) {
        const isChange = buttongroup.setActive({
          isActive: data.isActive,
          value: data.value,
          isAll: true
        });
        if (isChange) {
          nChange++;
        }
      }
    }
    if (nChange > 0) {
      this.saveCurrentData();
    }
    // this.saveAfterClick();
  }

  onInspectBtnChange(value: number, item: InspectRecommendSubItem) {
    const isDup = this.isDuplicate(item);
    if (!isDup) {
      this.service.setInspectResultRecomend2(value, item);
      this.changeStatus(item);
    }
  }

  changeStatus(item: InspectRecommendSubItem, checkCate?: boolean) {
    this.service.changeStatusRecommendSeibi2(item);
    if (checkCate !== false) {
      this.changeCateStatus();
    }
  }

  changeCateStatus() {
    let nItem = this.currentData.length;
    let sumStatus = 0;
    if (this.currentData && this.currentData.length > 0) {
      sumStatus = this.currentData.reduce(
        (sum, cur: InspectRecommendSubItem) =>
          sum + (cur.status ? cur.status : 0),
        0
      );
    }
    this.setCateStatus(sumStatus, nItem);
  }

  setCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectRecommendCategory
  ) {
    if (cate == null && this.data.recommend) {
      cate = this.data.recommend[this.activeCategory];
    }
    if (cate) {
      if (sumStatus == 0) {
        cate.status = InspectButtonStatus.NONE;
      } else if (sumStatus == nItem * InspectButtonStatus.COMPLETED) {
        cate.status = InspectButtonStatus.COMPLETED;
      } else {
        cate.status = InspectButtonStatus.INCOMPLETE;
      }
    }
  }

  // onRadioClick(item: InspectRecommendSubItem) {
  //   if (item.usePart != "0") {
  //     item.usePart = "0";
  //     this.onRadioChange(item);
  //   }
  // }

  // onRadioChange(item: InspectRecommendSubItem) {
  //   this.service.changeUsePart(item);
  //   this.changeStatus(item);
  // }

  isActive(i: number) {
    return this.activeCategory == i;
  }

  changeCategory(i: number) {
    this.activeCategory = i;
    this.currentData = [];
    this.kingakuFlg = false;
    this.$nextTick(() => {
      this.setCurrentData();
    });
    /** 2021-11-24 sh #7530 improve speed. (for back) [START] */
    /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
    const sknInspectCategoryId = this.posToSknInspectCategoryId(i)
    let routeInfo: RouteInfo = {
      apiPath: "recommend",
      sknInspectCategoryId: sknInspectCategoryId,
      pos: i,
      subPos: 0
    };
    this.setRouteInfo({ data: routeInfo, index: INSPECT_TYPE.RECOMMEND })
    /** 2021-11-24 sh #7530 improve speed. (for back) [END] */
  }

  isDuplicate(item: InspectRecommendSubItem) {
    return item.isInspectDuplicate == 1;
  }

  isDisabled(item: InspectRecommendSubItem) {
    if (item.osusumeIsShow) {
      return false;
    }
    return true;
  }

  isComplete(item: any) {
    return this.service.isComplete(item);
  }

  isIncomplete(item: any) {
    return this.service.isIncomplete(item);
  }

  isStatusNone(item: InspectRecommendSubItem) {
    return this.service.isStatusNone(item);
  }

  goTop() {
    let wrap = document.querySelector(".select-item-wrap");
    if (wrap) {
      wrap.scrollTop = 0;
    }
  }

  // saveData() {
  //   let objForSave = JSON.parse(JSON.stringify(this.data));
  //   objForSave.recommend.forEach((cate: InspectRecommendCategory) => {
  //     delete cate.status;
  //     cate.subItems.forEach((obj: InspectRecommendSubItem) => {
  //       delete obj.status;
  //       delete obj.showWork;
  //     });
  //   });
  //   return this.reqService.saveInspectRecommend(objForSave);
  // }

  saveCurrentData() {
    this.currentData.forEach(seibi => {
      seibi.isSaving = true;
    });
    let objForSave = util.deepCopy(this.currentData);
    if (this.data.recommend) {
      let id = this.data.recommend[this.activeCategory]
        .sknRecommendInspectCategoryId;
      objForSave.forEach((obj: InspectRecommendSubItem) => {
        delete obj.status;
        delete obj.showWork;
        delete obj.isSaving;
        obj.sknRecommendInspectCategoryId = id;
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        obj.buhinSelected = obj.osusumeIsShow == 0 ? STATUS_SELECT_WORK_BUHIN.delete : obj.buhinSelected;
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      });
      /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
      let objForSaveManual = objForSave.filter((e: any) => {
        return e.osusumeId == null && e.sknRecommendInspecSeibiId == null
      }).map((e: any) => {
        let manualItem = {
          sknUketsukeExtendsId: this.uketsukeExtendsId + ''
          , seibiId: e.seibiId
          , seibiNm: e.sknRecommendInspecSeibiNm
          , kouchinZn: e.kouchinZn
          , kouchinZk: e.kouchinZk
          , buhinSelected: e.osusumeIsShow == 1 ? STATUS_SELECT_WORK_BUHIN.Done : STATUS_SELECT_WORK_BUHIN.delete
          , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
          , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId: e.sknRecommendInspectCategoryId
          , osusumeIsShow: e.osusumeIsShow
          , buhinList: e.buhinList
          , manualBuhinList: e.manualBuhinList
          , osusumeBuhinList: e.osusumeBuhinList
        };
        return manualItem;
      });
      objForSave = objForSave.filter((e: any) => {
        return e.osusumeId != null || e.sknRecommendInspecSeibiId != null
      });
      /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
      const data = {
        isSocket: 1,
        recommend: [
          {
            sknRecommendInspectCategoryId: id,
            sknRecommendInspectCategoryNm: this.data.recommend[this.activeCategory].sknRecommendInspectCategoryNm,
            kingakuZk: this.data.recommend[this.activeCategory].kingakuZk,
            kingakuZn: this.data.recommend[this.activeCategory].kingakuZn,
            subItems: objForSave
            /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
            , manualItems: objForSaveManual
            /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
          }
        ]
      };
      this.saveAndUpdateData(data, true);
    }
  }

  getIsSocket() {
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [START] */
    // return this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    let isSocket = this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    if (isSocket == 0) {
      if (this.activeInspect && this.activeInspect.buhinList) {
        if (this.activeInspect.buhinList.length == 0 || this.activeInspect.buhinList.length == 1) {
          isSocket = 1;
        }
      }
      if (this.activeInspect && this.activeInspect.osusumeBuhinList) {
        if (this.activeInspect.osusumeBuhinList.length == 0 || this.activeInspect.osusumeBuhinList.length == 1) {
          isSocket = 1;
        }
      }
    }
    return isSocket;
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [END] */
  }

  getObjForSave(item: any = null) {
    let subItems: any = [];
    let manualItems: any = [];
    let items: any = [];
    if (!item) {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items = this.tempListSave;
      items = util.deepCopy(this.tempListSave);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    } else {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items.push(item);
      items = items.concat(item);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    }
    items.forEach((element: any) => {
        let buhinList: any = [];
        if (element.buhinList && element.buhinList.length > 0) {
          element.buhinList.forEach((element: any) => {
            buhinList.push({
              buhinCd: element.buhinCd
            , buhinId: element.buhinId
            , buhinNm: element.buhinNm
            , buhinPriceZk: element.buhinPriceZk
            , buhinPriceZn: element.buhinPriceZn
            , buhinShubetsuId:element.buhinShubetsuId
            , isDelete: element.isDelete
            , isExtreme: element.isExtreme
            , kingakuZk: element.kingakuZk
            , kingakuZn: element.kingakuZn
            , quantity: element.quantity
            , quantityStep: element.quantityStep
            , id: element.id ? element.id: null
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [START] */
            , buhinMasterZk: element.buhinMasterZk ? element.buhinMasterZk : 0
            , buhinMasterZn: element.buhinMasterZn ? element.buhinMasterZn : 0
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [END] */
            });
          });
        }
        let osusumeBuhinList: any = [];
        if (element.osusumeBuhinList && element.osusumeBuhinList.length > 0) {
          element.osusumeBuhinList.forEach((element: any) => {
            osusumeBuhinList.push({
                buhinCd: element.buhinCd
              , buhinId: element.buhinId
              , buhinLinkId: element.buhinLinkId
              , buhinNm: element.buhinNm
              , buhinOsusumeId: element.buhinOsusumeId
              , buhinPriceZk: element.buhinPriceZk
              , buhinPriceZn: element.buhinPriceZn
              , buhinShubetsuId: element.buhinShubetsuId
              , id: element.id
              , isDelete: element.isDelete
              , isExtreme: element.isExtreme
              , kingakuExtensionId: element.kingakuExtensionId
              , kingakuZk: element.kingakuZk
              , kingakuZn: element.kingakuZn
              , koukanMeyasuTime: element.koukanMeyasuTime
              , kousuu: element.kousuu
              , quantity: element.quantity
              , quantityStep: element.quantityStep
              /** #8299(BQR1105) It does not work discount when buhin count is 1. [START] */
              , buhinMasterZk: element.buhinMasterZk ? element.buhinMasterZk : 0
              , buhinMasterZn: element.buhinMasterZn ? element.buhinMasterZn : 0
              /** #8299(BQR1105) It does not work discount when buhin count is 1. [END] */
            });
          });
        }
      if (element.osusumeId != null || element.sknRecommendInspecSeibiId != null) {
        let subItem = {
            branchId: element.branchId
          , buhinBunruiList: element.buhinBunruiList ? element.buhinBunruiList: []
          , buhinList: buhinList
/** 2022-01-29 sh #7685 delete work after change teian from [suru] to [shinai]. [START] */
          // , buhinSelected: element.buhinSelected
          , buhinSelected: element.osusumeIsShow == 0 ? STATUS_SELECT_WORK_BUHIN.delete : element.buhinSelected
/** 2022-01-29 sh #7685 delete work after change teian from [suru] to [shinai]. [END] */
          , inspectResult: element.inspectResult
          , inspectValue: element.inspectValue
          , isDoTenken: element.isDoTenken
          , isInspectDuplicate: element.isInspectDuplicate
          , isNumber: element.isNumber
          , kouchinZn: element.kouchinZn
          , koukanMeyasuTime: element.koukanMeyasuTime
          , manualBuhinList: element.manualBuhinList ? element.manualBuhinList: []
          , osusumeBuhinList: osusumeBuhinList
          , osusumeId: element.osusumeId ? element.osusumeId: null
          , osusumeIsShow: element.osusumeIsShow
          , seibiId: element.seibiId
          , sknInspectSeibiDetailId: element.sknInspectSeibiDetailId
          , sknInspectType: element.sknInspectType
          , sknRecommendInspecSeibiId: element.sknRecommendInspecSeibiId
          , sknRecommendInspecSeibiNm: element.sknRecommendInspecSeibiNm
          , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId: element.sknRecommendInspectCategoryId
          , sknUketsukeExtendsId: element.sknUketsukeExtendsId
          , inspectQuantity: element.inspectQuantity ? element.inspectQuantity: null
          , kousuu: element.kousuu ? element.kousuu: null
          , buhinShubetsuCd: element.buhinShubetsuCd ? element.buhinShubetsuCd: null
          , kouchinZk: element.kouchinZk ? element.kouchinZk: null
          , isExtreme: element.isExtreme // 2022-01-18 sh #7656(BQR039) add isExtreme and workCd for save.
          , workCd: element.workCd // 2022-01-18 sh #7656(BQR039) for isExtreme and workCd for save.
        }
        subItems.push(subItem);
      } else {
        /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [START] */
        let manualItem = {
          sknUketsukeExtendsId: this.uketsukeExtendsId + ''
          , seibiId: element.seibiId
          , seibiNm: element.sknRecommendInspecSeibiNm
          , kouchinZn: element.kouchinZn
          , kouchinZk: element.kouchinZk
          , buhinSelected: element.osusumeIsShow == 1 ? STATUS_SELECT_WORK_BUHIN.Done : STATUS_SELECT_WORK_BUHIN.delete // modify
          , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
          , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId: element.sknRecommendInspectCategoryId
          , osusumeIsShow: element.osusumeIsShow // modify
          , buhinList: buhinList
          , manualBuhinList: element.manualBuhinList
          , osusumeBuhinList: osusumeBuhinList
        }
        /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [END] */
        manualItems.push(manualItem);
      }
    });
    const isSocket = this.getIsSocket();
    const data = {
      isSocket,
      recommend: [
        {
          subItems: subItems
          , manualItems: manualItems
        }
      ]
    };
    return data;
  }

  findSeibiIndex(list: any, seibiSave: any) {
    return list.findIndex(
      (seibi: any) =>
        (seibi.sknRecommendInspecSeibiId &&
          seibi.sknRecommendInspecSeibiId ==
            seibiSave.sknRecommendInspecSeibiId) ||
        (seibi.osusumeId && seibi.osusumeId == seibiSave.osusumeId)
    );
  }

  saveSeibiItem(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.recommend, inspectItem);
    }
    // if (inspectItem.status == InspectButtonStatus.COMPLETED) {
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    // if (
    //   inspectItem.inspectResult == InspectButtonValue.CIRCLE &&
    //   inspectItem.manualBuhinList.length > 0
    // ) {
    //   inspectItem.manualBuhinList.forEach(buhin => {
    //     if (buhin.buhinId) {
    //       this.reqService.deleteManualBuhin(buhin.buhinId);
    //     }
    //   });
    // }
    let objForSave: InspectRecommendSubItem = JSON.parse(
      JSON.stringify(inspectItem)
    );
    this.arrStatus.push(objForSave.status || 0);
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.isSaving;
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        objForSave.osusumeBuhinList.forEach((e: any) => {
          if (e.hasOwnProperty("isSelected")) {
            delete e.isSelected;
          }
        });
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      }
    }
    if (this.data.recommend) {
      objForSave.sknRecommendInspectCategoryId = this.data.recommend[
        this.activeCategory
      ].sknRecommendInspectCategoryId;
    }
    if (this.isSaving) {
      let index = -1;
      if (this.tempWaitSave.length > 0) {
        index = this.findSeibiIndex(this.tempWaitSave, objForSave);
      }
      if (index > -1) {
        this.tempWaitSave[index] = objForSave;
      } else {
        this.tempWaitSave.push(objForSave);
      }
    } else {
      let index = -1;
      index = this.findSeibiIndex(this.tempListSave, objForSave);
      if (index > -1) {
        this.tempListSave[index] = objForSave;
      } else {
        this.tempListSave.push(objForSave);
      }
      this.timerSave = setTimeout(() => {
        if (this.tempListSave.length > 0) {
          const data = this.getObjForSave();
          this.saveAndUpdateData(data);
        }
      }, 1000);
    }
  }

  saveBuhin(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.recommend, inspectItem);
    }
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    let objForSave: InspectRecommendSubItem = JSON.parse(
      JSON.stringify(inspectItem)
    );
    this.arrStatus.push(objForSave.status || 0);
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.isSaving;
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
      }
    }
    if (this.data.recommend) {
      objForSave.sknRecommendInspectCategoryId = this.data.recommend[
        this.activeCategory
      ].sknRecommendInspectCategoryId;
    }
    if (this.isSaving) {
      let index = -1;
      if (this.tempWaitSave.length > 0) {
        index = this.findSeibiIndex(this.tempWaitSave, objForSave);
      }
      if (index > -1) {
        this.tempWaitSave[index] = objForSave;
      } else {
        this.tempWaitSave.push(objForSave);
      }
    } else {
      let index = -1;
      index = this.findSeibiIndex(this.tempListSave, objForSave);
      if (index > -1) {
        this.tempListSave[index] = objForSave;
      } else {
        this.tempListSave.push(objForSave);
      }
    }
  }

  saveAndUpdateData(data: any, isUpdateAll: boolean = false) {
    this.isSaving = true;
    this.reqService.saveInspectRecommend(data).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          this.isSocket = true;
          this.isSaving = false;
          /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [START] */
//          data.recommend[0].subItems
//            .map((item: any) => item.sknRecommendInspecSeibiId)
//            .forEach((key: number) => {
//              const target = this.currentData.findIndex(
//                (i: InspectRecommendSubItem) =>
//                  i.sknRecommendInspecSeibiId === key
//              );
//              if (target > -1) {
//                this.currentData[target].isSaving = false;
//              }
//            });
          //怪しい//更新後、緑画面にレスポンスしているか
          console.log("z1",data.recommend[0].subItems);
          data.recommend[0].subItems
            .map((item: any) => { return {id: item.sknRecommendInspecSeibiId, isExtreme: item.isExtreme} })
            .forEach((key: any) => {
              const target = this.currentData.findIndex(
                (i: InspectRecommendSubItem) =>
                  i.sknRecommendInspecSeibiId === key.id && i.isExtreme == key.isExtreme
              );
              if (target > -1) {
                this.currentData[target].isSaving = false;
              }
            });
          /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [END] */
          if (this.tempWaitSave.length > 0) {
            const data = this.getObjForSave(util.deepCopy(this.tempWaitSave));
            this.saveAndUpdateData(data);
            this.tempWaitSave = [];
          }
          this.tempListSave = [];
          this.arrStatus = [];
          this.initData(res.body);
          // if (res.body.isSocket) {
          //   let doInit = false;
          //   if (isUpdateAll) {
          //     doInit = true;
          //   } else {
          //     const subItems = data.recommend[0].subItems;
          //     if (
          //       subItems.length == 1 &&
          //       subItems[0].buhinSelected == STATUS_SELECT_WORK_BUHIN.Done
          //     ) {
          //       doInit = true;
          //     }
          //   }
          //   if (doInit) {
          //     this.initData(res.body);
          //   }
          // }
        }
      },
      error => {
        console.error("error", error.rsltComment);
        let arrNm = this.tempListSave.map(
          inspect => inspect.sknRecommendInspecSeibiNm
        );
        if (arrNm.length > 0) {
          this.$notify.error({
            title: "エラー",
            message: arrNm.join()
          });
        }
      }
    );
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    // this.loading = true;
    // this.saveData().then(
    //   res => {
    //     this.loading = false;
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
    //   },
    //   (res: any) => {
    //     this.onError(res);
    //   }
    // );
  }

  onRegister() {
    this.$emit("saveSpentTime");
    // let status = this.service.getRegisterStatus(this.data.recommend);
    // this.$emit("onregister", { pageName: this.$route.name, status });
    this.$emit("onregister", { pageName: this.$route.name });
  }

  goNextCate() {
    this.clickCount = 0;
    if (
      this.data.recommend &&
      this.activeCategory < this.data.recommend.length - 1
    ) {
      this.activeCategory++;
      this.changeCategory(this.activeCategory);
    }
  }

  goBackCate() {
    this.clickCount = 0;
    if (this.activeCategory > 0) {
      this.activeCategory--;
      this.changeCategory(this.activeCategory);
    }
  }

  get showBtnBack() {
    if (this.activeCategory > 0) {
      return true;
    }
    return false;
  }

  get backCate() {
    if (this.showBtnBack && this.data.recommend) {
      return this.data.recommend[this.activeCategory - 1]
        .sknRecommendInspectCategoryNm;
    }
    return "";
  }

  get showBtnNext() {
    if (
      this.data.recommend &&
      this.activeCategory < this.data.recommend.length - 1
    ) {
      return true;
    }
    return false;
  }

  get nextCate() {
    if (this.showBtnNext && this.data.recommend) {
      return this.data.recommend[this.activeCategory + 1]
        .sknRecommendInspectCategoryNm;
    }
    return "";
  }

  // saveAfterClick() {
  //   if (this.timerSave) {
  //     clearTimeout(this.timerSave);
  //   }
  //   this.timerSave = setTimeout(() => {
  //     this.saveData();
  //   }, 1000);
  // }

  showWork(event: any, item: any) {
    item.showWork = !item.showWork;
    if (item.showWork) {
      this.activeInspect = item;
    } else {
      this.activeInspect = {};
    }
  }

  resetBtnPriotity(index: number) {
    let buttongroup = this.$refs.buttonGroup[index] as ButtonInspectGroup;
    buttongroup.setActive({
      isActive: true,
      value: 0,
      isAll: false
    });
  }

  deleteAlManualBuhin(item: any) {
    if (item.manualBuhinList.length > 0) {
      const manualBuhinList = util.deepCopy(item.manualBuhinList);
      item.manualBuhinList = [];
      manualBuhinList.forEach((buhin: any) => {
        if (buhin.id) {
          this.reqService.deleteManualBuhin(buhin.id);
        }
      });
    }
  }

  onChangeShow(item: any, index: number) {
    if (item.isInspectDuplicate && item.osusumeIsShow) {
      this.errorMsg = "現車確認又は57項目点検で関連する点検項目が「×」になっている為解除できません。";
      this.$refs.errorDialog.onOpen();
    } else if (item.buhinSelected == 0 || item.osusumeIsShow == 0) {
      item.osusumeIsShow = item.osusumeIsShow ? 0 : 1;
      if (item.osusumeIsShow == 0) {
        item.inspectResult = 0;
        // this.resetBtnPriotity(index);
      }
      this.activeInspect = item;
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeStatus(item);
      item.osusumeBuhinList = null;
      item.buhinList = [];
      this.saveSeibiItem(item);
    } else {
      this.askConfirmChange(item, index);
    }
  }

  onConfirmChangeInspect() {
    this.arrStatus.push(InspectButtonStatus.COMPLETED);
    this.activeInspect = {};
    this.tempInspect.osusumeIsShow = 0;
    // this.resetBtnPriotity(this.tempIndex);
    this.service.setInspectResultRecomend2(0, this.tempInspect);
    if (this.tempInspect.isInspectDuplicate == 0) {
      this.deleteAlManualBuhin(this.tempInspect);
      this.service.deletAllBuhinInSebi([this.tempInspect]);
      this.tempInspect.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
    this.changeStatus(this.tempInspect);
    this.saveSeibiItem(this.tempInspect);
    this.$refs.confirmDialog.onClose();
  }

  onCancelChangeInspect() {
    this.$refs.confirmDialog.onClose();
  }

  askConfirmChange(item: InspectRecommendSubItem, index: number) {
    this.$refs.confirmDialog.onOpen();
    this.tempInspect = item;
    this.tempIndex = index;
  }

  onConfirmBuhin(item: InspectRecommendSubItem) {
    this.changeStatus(item);
    this.saveBuhin(item);
  }

  buttonLabel(inspect: any) {
    if (inspect.buhinSelected == 0) {
      return "選択";
    }
    return "選択済";
  }

  hasValueWork(inspect: any) {
    if (inspect.buhinSelected != null && inspect.buhinSelected > 0) {
      return "green";
    } else if (this.isIncomplete(inspect)) {
      return "red";
    }
    return "normal bold";
  }

  isShow(inspect: any) {
    if (inspect.osusumeIsShow) {
      return "green";
    }
    return "normal bold";
  }

  isShowAll(show: number) {
    return this.currentData.every(seibi => seibi.osusumeIsShow == show);
  }

  showAll() {
    if (this.isShowAll(1)) {
      return;
    }
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    this.currentData.forEach((item: any) => {
      item.osusumeIsShow = 1;
    // this.currentData.forEach(item => {
    //  item.osusumeIsShow = 1;
      // if (!item.osusumeBuhinList || (item.osusumeBuhinList && item.osusumeBuhinList.length == 0)) {
      //   item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      // }
      if (item.buhinList && item.buhinList.length == 0 && item.osusumeBuhinList && item.osusumeBuhinList.length == 0) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (!item.osusumeBuhinList && item.buhinBunruiList && item.buhinBunruiList.length == 0 && item.buhinList && item.buhinList.length == 0) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (item.osusumeBuhinList && item.osusumeBuhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else if (item.buhinList && item.buhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
        if (item.buhinList && item.buhinList.length > 0) {
          item.buhinList = new Array();
        }
        if (item.osusumeBuhinList && item.osusumeBuhinList.length > 0) {
          item.osusumeBuhinList = new Array();
        }
      }
      /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeStatus(item);
    });
    this.saveCurrentData();
  }

  hideAll() {
    if (this.isShowAll(0)) {
      return;
    }
    this.currentData.forEach((item, i) => {
      if (item.isInspectDuplicate == 0) {
        item.osusumeIsShow = 0;
        this.service.setInspectResultRecomend2(item.inspectResult, item);
        // this.resetBtnPriotity(i);
        this.deleteAlManualBuhin(item);
        this.service.deletAllBuhinInSebi([item]);
      }
    });
    this.saveCurrentData();
  }

  beforeDestroy() {
    if (this.timerSave) {
      if (this.tempListSave.length > 0) {
        /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
        // this.reqService.saveInspectRecommend(this.getObjForSave());
        if (this.$route.name !== "quickitemselection" && this.$route.name !== "quickmitsumori" && this.$route.name !== "quickinfo") {
          this.reqService.saveInspectRecommend(this.getObjForSave());
        }
        /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */
      }
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    if (Object.keys(this.activeInspect).length > 0) {
      this.activeInspect.showWork = false;
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  getQmMitsumoriPreviewPM() {
    const promise = new Promise((resolve, reject) => {
      this.reqService.getQmMitsumoriPreview(this.uketsukeExtendsId).then((res: any) => {
        resolve(res);
      }, error => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
        reject();
      });
    });
    return promise;
  }

  get checkQmMitsumoriBtn() {
    if (this.functionSettingState && this.functionSettingState.isCanUseQuickMitsumori === 1) {
      if (this.uketsukeExtendsId && this.qmMitsumori
        && this.qmMitsumori.isCanUseQuickMitsumori === 1
        && this.qmMitsumori.isHasQuickMitsumori === 1) {
        return true;
      }
    }
    return false;
  }
  /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
  addcurrentData() {
    if (this.seibiNm.length > 0) {
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [START] */
      let item = {
        sknUketsukeExtendsId: this.uketsukeExtendsId + ''
        , sknRecommendInspecSeibiNm: this.seibiNm
        , kouchinZn: this.kouchinZn
        , buhinSelected: STATUS_SELECT_WORK_BUHIN.Done
        , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
        , osusumeIsShow: 1 // add
        , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId: 0: 0
      }
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [END] */
      this.arrStatus.push(InspectButtonStatus.COMPLETED);
      this.saveManualItem(item);
    }
  }

  saveManualItem(item: any) {
    this.activeInspect = item;
    /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
    this.isSaving = true;
    /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
    this.reqService.saveInspectRecommendManual(this.getObjForSave(item)).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          let data: InspectRecommendSubItem = {
            sknUketsukeExtendsId: this.uketsukeExtendsId
            , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
            , branchId: '0'
            , inspectResult: 0
            , isNumber: 0
            , inspectValue: 0
            , seibiId: res.body
            , sknInspectCommentId: 0
            , inspectValueList: []
            , inspectValueViewType: 0
            , koukanMeyasuTime: 0
            , sknRecommendInspecSeibiId: null
            , sknRecommendInspecSeibiNm: this.seibiNm
            , sknInspectSeibiDetailId: 0
            , isInspectDuplicate: 0
            , kingaku: this.kouchinZn
            , kouchinZn: this.kouchinZn
            , buhinSelected: STATUS_SELECT_WORK_BUHIN.Done
            , buhinList: []
            , manualBuhinList: []
            , osusumeIsShow: 1
            , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId: 0: 0
            , osusumeBuhinList: []
            , isDoTenken: 0
            , rowNum: this.currentData.length
            , isSaving: false
            , status: InspectButtonStatus.COMPLETED
          }
          this.currentData.push(data);
          if (this.data && this.data.recommend && this.data.recommend.length > 0 && this.data.recommend[this.activeCategory].subItems && this.data.recommend[this.activeCategory].subItems.length > 0) {
            this.data.recommend[this.activeCategory].subItems.push(data);
          }
          this.seibiNm = "";
          this.kouchinZn = null;
          this.kingakuFlg = false;
        }
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
        this.isSaving = false;
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
      },
      error => {
        console.error("error", error);
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
        this.isSaving = false;
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
      }
    );
  }

  onCloseBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    if (event.isResetSeibi || event.isChange) {
      if (event.isSocket) {
        this.isSocket = true;
      } else {
        this.isSocket = false;
      }
      this.changeStatus(this.activeInspect);
      const data = this.getObjForSave(this.activeInspect);
      this.saveAndUpdateData(data);
    }
    this.$set(this, "activeInspect", {});
  }

  /** 2021-11-24 sh #7530 improve speed.(for back) [START] */
  hasLastSelectedCategoryId() {
    return this.hasLastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND);
  }

  getLastSelectedCategoryId() {
    let sknInspectCategoryId: any;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND);
      if (lastCategoryInfo && lastCategoryInfo.sknInspectCategoryId) {
        sknInspectCategoryId = lastCategoryInfo.sknInspectCategoryId;
      }
    }
    return sknInspectCategoryId;
  }

  getLastSelectedPos() {
    let pos: number = -1;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND);
      if (lastCategoryInfo && lastCategoryInfo.pos !=null) {
        pos = lastCategoryInfo.pos;
      }
    }
    return pos;
  }

  posToSknInspectCategoryId(pos: any) {
    let sknInspectCategoryId: any;
    let cnt = 0;
    if (this.data.recommend) {
      this.data.recommend.forEach((cate: any) => {
        if (cate && cate.sknInspectCategoryId && cnt == pos) {
          sknInspectCategoryId = cate.sknInspectCategoryId;
        }
        cnt++;
      });
    }
    return sknInspectCategoryId;
  }

  changeCategoryByLastSelected(length: number) {
    if (this.hasLastSelectedCategoryId()){
      const pos = this.getLastSelectedPos()
      if (pos > -1 && length > pos) {
        this.changeCategory(Number(pos));
      }
    }
  }
  /** 2021-11-24 sh #7530 improve speed.(for back) [END] */

  /** 2022-01-27 sh #7676(BQR061) add condition of tooltip. [START] */
  tooltipMessage(child: any) {
    if (this.isDuplicate(child)) {
      return '※現車確認又は57項目点検で金額を確定しているため、編集出来ません。現車確認又は57項目点検で編集してください。';
    }
    return '※金額を編集したい場合は、「提案する」を押した後、「選択」後に表示される画面で行ってください。';
  }
  /** 2022-01-27 sh #7676(BQR061) add condition of tooltip. [END] */

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
  onConnect() {
    this.sktControll.socketInspectionsBase(this.getInitData);
  }
  destroyed() {
    this.sktControll.freeSocketResources();
  }
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
}
